import { Api } from '@/common/utils';

const basePath = (decedentId) => `/decedent/${decedentId}/note`;

export const getDecedentNotes = (decedentId) =>
  Api.request({
    url: `${basePath(decedentId)}/list`,
  });

export const createDecedentNote = (decedentId, payload) =>
  Api.request({
    url: `${basePath(decedentId)}/create`,
    method: 'post',
    payload,
  });

export const updateDecedentNote = (decedentId, noteId, payload) =>
  Api.request({
    url: `${basePath(decedentId)}/${noteId}`,
    method: 'put',
    payload,
  });

export const deleteDecedentNote = (decedentId, noteId) =>
  Api.request({
    url: `${basePath(decedentId)}/${noteId}`,
    method: 'delete',
  });

export const addDecedentNoteItem = (decedentId, noteId, payload) =>
  Api.request({
    url: `${basePath(decedentId)}/${noteId}/item/create`,
    method: 'post',
    payload,
  });

export const updateDecedentNoteItemState = (decedentId, noteId, itemId, payload) =>
  Api.request({
    url: `${basePath(decedentId)}/${noteId}/item/${itemId}/state`,
    method: 'put',
    payload,
  });

export const deleteDecedentNoteItem = (decedentId, noteId, itemId) =>
  Api.request({
    url: `${basePath(decedentId)}/${noteId}/item/${itemId}`,
    method: 'delete',
  });
